import { useContext } from 'react'

import { SingleSeriesContext } from '../providers/SingleSeriesProvider'

export const useSingleSeriesContext = () => {
  const singleSeriesContext = useContext(SingleSeriesContext)

  if (singleSeriesContext === undefined) {
    throw new Error('singleSeriesContext must be used within a SingleSeriesProvider')
  }

  return singleSeriesContext
}
